export enum SubwayRoleType {
  SUBWAY_FR_FN = 'subway_fr-fn',
  SUBWAY_FR = 'fn',
}
